<template>
  <b-row>
    <b-col>
      <h2>Seleccione Pallets ({{ markedRows.length }} seleccionados)</h2>
      <v-client-table :columns="columns" :data="data" :options="options" :theme="theme" id="dataTable">
        <template slot="id" slot-scope="props">
          <input
            type="checkbox"
            :ref="'check' + props.index"
            @click="
              unmarkAll($event, props.row.id, props.index, 'check' + props.index, props.row.dispatch_waybill_number)
            "
            class="form-check"
            :value="props.row"
            v-model="markedRows"
          />
        </template>
        <template slot="afterFilter">
          <b-form-checkbox v-model="justApprobed" name="checkbox-1" :value="true" :unchecked-value="false" :disabled="!$store.state.user.scope.includes('puede-agregar-pallets-sin-aprobar-en-packing-list-embarque')"
            >Sólo aprobados</b-form-checkbox
          >
        </template>

        <template slot="approve" slot-scope="props">
          <div style="text-align: center">
            <template v-if="props.row.approve == 1">
              <b-badge pill variant="success">Aprobado</b-badge>
            </template>
            <template v-else>
              <b-badge pill variant="light">No Aprobado</b-badge>
            </template>
          </div>
        </template>
        <div slot="afterFilter"></div>

        <div slot="dispatch_waybill_date" slot-scope="props">
          <div style="text-align: right">
            {{ props.row.dispatch_waybill_date }}
          </div>
        </div>
      </v-client-table>
    </b-col>
  </b-row>
</template>

<script>
import Vue from "vue";
import { ClientTable, Event } from "vue-tables-2";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import { ModelSelect } from "vue-search-select";
import { bus } from "../../main";
numeral.locale("es");

var d = new Date();

Vue.use(ClientTable);
Vue.component("downloadExcel", JsonExcel);

export default {
  name: "formListaEmbarquePallet",
  components: {
    ClientTable,
    ModelSelect
  },
  mounted() {
    //this.getPallet(this.selected.month, this.selected.condition, this.selected.product, this.selected.product_type);
  },
  created() {
    bus.$off("onChangeBording");
    bus.$on("onChangeBording", (data) => {
      this.idBording = data;
      this.markedRows = [];

      this.$axios
        .get(
          "/api/v1/pallet/packing_list_pallets/?" + "bording_id=" + data + "&" + "just_approved=" + this.justApprobed
        )
        .then((res) => {
          const data = res.data.shipment;
          const items = [];

          for (let key in data) {
            const item = data[key];
            items.push(item);
          }

          const data2 = res.data.pallet_shipment;
          for (let key in data2) {
            const item = data2[key];
            items.unshift(item);
            this.markedRows.push(item);
          }

          this.data = items;
        })
        .catch((error) => console.log(errors));
    });
  },
  watch: {
    justApprobed(newVal) {
      // Actualiza los dato de la pagina
      console.log('ACAACKK!!🐔', newVal);
      this.getTableData();
    }
  },
  data() {
    return {
      idBording: "",
      optionsa: [
        { value: "", text: "Todos" },
        { value: "1", text: "Aprobado" },
        { value: "0", text: "No Aprobado" }
      ],
      selectaproveed: "-",
      markedRows: [],
      justApprobed: true,
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],

      columns: [
        "id",
        "number",
        "_origins",
        "_container",
        "_varieties",
        "_total_quantity",
        // TODO: add sif_number when query is optimized
        // "sif_number",
        "approve",
        "purchase_order",
        "_total_net_kilograms"
        // 'total_gross_kilograms',
      ],
      selected: {
        product: "",
        product_type: "",
        condition: "",
        month: d.getMonth() + 1
      },
      selectOptions: {
        products: [],
        product_types: [],
        conditions: [
          { value: "", text: "-------" },
          { value: "Orgánico", text: "Orgánico" },
          { value: "Convencional", text: "Convencional" },
          { value: "Org. (System)", text: "Org. (System)" },
          { value: "Conv. (System)", text: "Conv. (System)" }
        ],
        months: [
          { value: 1, text: "Enero" },
          { value: 2, text: "Febrero" },
          { value: 3, text: "Marzo" },
          { value: 4, text: "Abril" },
          { value: 5, text: "Mayo" },
          { value: 6, text: "Junio" },
          { value: 7, text: "Julio" },
          { value: 8, text: "Agosto" },
          { value: 9, text: "Septiembre" },
          { value: 10, text: "Octubre" },
          { value: 11, text: "Noviembre" },
          { value: 12, text: "Diciembre" }
        ]
      },
      productSet: [],
      data: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        filterByColumn: true,
        listColumns: {
          approve: [
            { id: 1, text: "Aprobado" },
            { id: 0, text: "No Aprobado" }
          ]
        },
        texts: {
          noResults: "No se encontraron registros.",
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        perPage: 10,
        dateFormat: "DD/MM/YYYY",
        // columnsDropdown: true,

        headings: {
          id: "",
          number: "Pallet",
          _origins: "Huertos",
          _container: "Formato",
          _varieties: "Variedades",
          sif_number: "Numero SIF",
          approve: "Estatus",
          purchase_order: "OP",
          _total_quantity: "Cajas",
          _total_net_kilograms: "kilogramos netos",
          _total_gross_kilograms: "kilogramos brutos"
        },
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 25
        }
      }
    };
  },
  methods: {
    getTableData() {
      this.$axios
        .get(
          "/api/v1/pallet/packing_list_pallets/?" + "bording_id=" + this.idBording + "&" + "just_approved=" + this.justApprobed
        )
        .then((res) => {
          const data = res.data.shipment;
          const items = [];

          for (let key in data) {
            const item = data[key];
            items.push(item);
          }

          const data2 = res.data.pallet_shipment;
          for (let key in data2) {
            const item = data2[key];
            items.unshift(item);
            this.markedRows.push(item);
          }

          this.data = items;
        })
        .catch((error) => console.log(errors));
    },
    onChange(event) {
      console.log(event.value);
    },
    filterStatus() {
      console.log("asd");
    },
    getpalletscheck() {
      return this.markedRows;
    },
    unmarkAll($event, id_pallet, index, obj, dispatch_waybill_number) {
      //console.log($event.target.checked);

      if ($event.target.checked == false) {
        if (dispatch_waybill_number == null) {
        } else {
          this.$swal
            .fire({
              title: "Seguro que quieres realizar esta operación?",
              text:
                "El pallet que quiere eliminar ya se encuentra en la guia de despacho (" +
                dispatch_waybill_number +
                "),\
               si acepta se eliminara el pallet de la guia de despacho (" +
                dispatch_waybill_number +
                ")  y de esta lista.",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#20a8d8",
              cancelButtonColor: "#f86c6b",
              cancelButtonText: "No",
              confirmButtonText: "SI ELIMINAR"
            })
            .then((result) => {
              if (result.value) {
                const formData = {
                  shipment_id: this.idBording,
                  id_pallet: id_pallet
                };

                this.$axios
                  .delete("/api/v1/pallet/delete_pallet_dispatch_waybill/", {
                    data: formData
                  })
                  .then((res) => {
                    this.$swal.fire("Operación realizada con exito", "", "success");
                    this.getPallet();
                  })
                  .catch((error) => console.log(errors));
              } else {
                this.$refs[obj].checked = true;
              }
            });
        }

        console.log("des chekiando" + id_pallet);
      } else {
        console.log("chekiando");
      }

      this.allMarked = false;
    },
    getPallet() {
      this.$axios
        .get(
          "/api/v1/pallet/packing_list_pallets/?" +
            "bording_id=" +
            this.idBording +
            "&" +
            "just_approved=" +
            this.justApprobed
        )
        .then((res) => {
          this.markedRows = [];
          const data = res.data.shipment;
          const items = [];
          for (let key in data) {
            const item = data[key];
            items.push(item);
          }

          const data2 = res.data.pallet_shipment;

          for (let key in data2) {
            const item = data2[key];
            items.unshift(item);
            this.markedRows.push(item);
          }
          this.data = items;
        })
        .catch((error) => console.log(errors));
    },

    getProductSet(a) {
      this.$axios
        .get("/production/get_product_set/" + a)
        .then((res) => {
          this.selectOptions.product_types = res.data.product_types;
        })
        .catch((error) => console.log("Product not selected."));
    }
  }
};
</script>

<style>
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
    padding: 0.25rem;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
